import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'register.page.title': {
    id: 'register.page.title',
    defaultMessage: 'Register | {siteName}',
    description: 'register page title',
  },
  // Field labels
  'registration.fullname.label': {
    id: 'registration.fullname.label',
    defaultMessage: 'Full name',
    description: 'Label that appears above fullname field',
  },
  'registration.first_name.label': {
    id: 'registration.first_name.label',
    defaultMessage: 'First Name',
    description: 'Label that appears above fullname field',
  },
  'registration.last_name.label': {
    id: 'registration.last_name.label',
    defaultMessage: 'Last Name',
    description: 'Label that appears above fullname field',
  },
  'registration.full_name.input.placeholder': {
    id: 'registration.full_name.input.placeholder',
    defaultMessage: 'Full name',
    description: 'Label that appears above fullname field',
  },
  'registration.full_name.placeholder': {
    id: 'registration.full_name.placeholder',
    defaultMessage: 'What is your full name?',
    description: 'Placeholder that appears above fullname field',
  },
  'registration.email.label': {
    id: 'registration.email.label',
    defaultMessage: 'Email',
    description: 'Label that appears above email field on register page',
  },
  'registration.username.label': {
    id: 'registration.username.label',
    defaultMessage: 'Public username',
    description: 'Label that appears above username field',
  },
  'registration.password.label': {
    id: 'registration.password.label',
    defaultMessage: 'Password',
    description: 'Label that appears above password field',
  },
  'confirm.your.password': {
    id: 'confirm.your.password',
    defaultMessage: 'Confirm your password',
    description: 'Field validation message when confirm password is empty',
  },
  'passwords.do.not.match': {
    id: 'passwords.do.not.match',
    defaultMessage: 'Passwords must match',
    description: 'Password format error.',
  },
  'registration.country.label': {
    id: 'registration.country.label',
    defaultMessage: 'Country/Region',
    description: 'Placeholder for the country options dropdown.',
  },
  'registration.opt.in.label': {
    id: 'registration.opt.in.label',
    defaultMessage:
      'I hereby confirm receiving updates on new courses, content and new learning initiatives',
    description: 'Text for opt in option on register page.',
  },
  // Help text
  'help.text.name': {
    id: 'help.text.name',
    defaultMessage: 'This name will be used by any certificates that you earn.',
    description: 'Help text for fullname field on registration page',
  },
  'help.text.username.1': {
    id: 'help.text.username.1',
    defaultMessage: 'The name that will identify you in your courses.',
    description: 'Part of help text for username field on registration page',
  },
  'help.text.username.2': {
    id: 'help.text.username.2',
    defaultMessage: 'This can not be changed later.',
    description: 'Part of help text for username field on registration page',
  },
  'help.text.email': {
    id: 'help.text.email',
    defaultMessage: 'For account activation and important updates',
    description: 'Help text for email field on registration page',
  },
  // Form buttons
  'create.account.for.free.button': {
    id: 'create.account.for.free.button',
    defaultMessage: 'Create Account',
    description: 'Label text for registration form submission button',
  },
  'registration.other.options.heading': {
    id: 'registration.other.options.heading',
    defaultMessage: 'Or',
    description:
      'A message that appears above third party auth providers i.e saml, google, facebook etc',
  },
  'create.account.cta.button': {
    id: 'create.account.cta.button',
    defaultMessage: '{label}',
    description:
      'Label text for registration form submission button for those users who are landing through redirections',
  },
  // Institution login
  'register.institution.login.button': {
    id: 'register.institution.login.button',
    defaultMessage: 'Institution/campus credentials',
    description: 'shows institutions list',
  },
  'register.institution.login.page.title': {
    id: 'register.institution.login.page.title',
    defaultMessage: 'Register with institution/campus credentials',
    description: 'Heading of institution page',
  },
  // Validation messages
  'empty.name.field.error': {
    id: 'empty.name.field.error',
    defaultMessage: 'Please enter your Full Name.',
    description: 'Error message for empty fullname field',
  },
  'empty.first_name.field.error': {
    id: 'empty.first_name.field.error',
    defaultMessage: 'Enter your first name',
    description: 'Error message for empty first name field',
  },
  'empty.last_name.field.error': {
    id: 'empty.last_name.field.error',
    defaultMessage: 'Enter your last name',
    description: 'Error message for empty last name field',
  },
  'empty.full_name.field.error': {
    id: 'empty.full_name.field.error',
    defaultMessage: 'Enter your full name',
    description: 'Error message for empty full name field',
  },
  'invalid.full_name.field.error': {
    id: 'invalid.full_name.field.error',
    defaultMessage: 'Name is invalid',
    description: 'Error message for invalid chars full name field',
  },
  'empty.email.field.error': {
    id: 'empty.email.field.error',
    defaultMessage: 'Please enter your Email.',
    description: 'Error message for empty email field',
  },
  'empty.username.field.error': {
    id: 'empty.username.field.error',
    defaultMessage: 'Please enter your Public Username.',
    description: 'Error message for empty username field',
  },
  'empty.password.field.error': {
    id: 'empty.password.field.error',
    defaultMessage: 'Please enter your Password.',
    description: 'Error message for empty password field',
  },
  'empty.country.field.error': {
    id: 'empty.country.field.error',
    defaultMessage: 'Select your country or region of residence',
    description: 'Error message when no country/region is selected',
  },
  'unchecked.terms.of.service.error': {
    id: 'unchecked.terms.of.service.error',
    defaultMessage: 'You must agree to the Campus IL Terms of Service',
    description: '',
  },
  'terms.of.service.checkbox.label': {
    id: 'terms.of.service.checkbox.label',
    defaultMessage: 'I accept {platform_name} {termsLink}',
    description: '',
  },
  'terms.of.service.text': {
    id: 'terms.of.service.text',
    defaultMessage: 'Terms of Service',
    description: '',
  },
  'email.do.not.match': {
    id: 'email.do.not.match',
    defaultMessage: 'The email addresses do not match.',
    description: 'Email not match to confirm email',
  },
  'email.invalid.format.error': {
    id: 'email.invalid.format.error',
    defaultMessage: 'Enter a valid email address',
    description: 'Validation error for invalid email address',
  },
  'email.validation.message': {
    id: 'email.validation.message',
    defaultMessage: 'Please enter your Email.',
    description: 'Validation message that appears when email is empty',
  },
  'username.validation.message': {
    id: 'username.validation.message',
    defaultMessage: 'Username must be between 2 and 30 characters',
    description: 'Error message for empty username field',
  },
  'name.validation.message': {
    id: 'name.validation.message',
    defaultMessage: 'Enter a valid name',
    description: 'Validation message that appears when fullname contain URL',
  },
  'name.validation.special.characters.message': {
    id: 'name.validation.special.characters.message',
    defaultMessage: 'Please enter a name without any special characters',
    description: '',
  },
  'name.validation.numbers.message': {
    id: 'name.validation.numbers.message',
    defaultMessage: 'Please enter a name without a number',
    description: '',
  },
  'first_name.validation.message': {
    id: 'first_name.validation.message',
    defaultMessage: 'Enter a valid first name',
    description: 'Validation message that appears when first name contain URL',
  },
  'last_name.validation.message': {
    id: 'last_name.validation.message',
    defaultMessage: 'Enter a valid last name',
    description: 'Validation message that appears when last name contain URL',
  },
  'full_name.validation.message': {
    id: 'full_name.validation.message',
    defaultMessage: 'Please enter your first and last name',
    description: 'Label that appears above fullname field',
  },
  'full_name.validation.numbers.message': {
    id: 'full_name.validation.numbers.message',
    defaultMessage: 'Please enter a name without a number',
    description:
      'Validation message that appears when full name contain a number',
  },
  'full_name.validation.special.characters.message': {
    id: 'full_name.validation.special.characters.message',
    defaultMessage: 'Please enter a name without any special characters',
    description:
      'Validation message that appears when full name contain special characters',
  },
  'password.validation.onlyenglish.message': {
    id: 'password.validation.onlyenglish.message',
    defaultMessage: 'Password must contain only english letters',
    description: 'Error message short password',
  },
  'password.validation.short.message': {
    id: 'password.validation.short.message',
    defaultMessage:
      'This password is too short. It must contain at least 12 characters.',
    description: 'Error message short password',
  },
  'password.validation.digit.message': {
    id: 'password.validation.digit.message',
    defaultMessage: 'This password must contain at least 1 digit.',
    description: 'Error message for password without a digit',
  },
  'password.validation.letter.message': {
    id: 'password.validation.letter.message',
    defaultMessage: 'This password must contain at least 1 letter.',
    description: 'Error message for password without a letter',
  },
  'password.validation.uppercase.message': {
    id: 'password.validation.uppercase.message',
    defaultMessage: 'This password must contain at least 1 upper case letter.',
    description: 'Error message for password without a upper case letter',
  },
  'password.validation.lowercase.message': {
    id: 'password.validation.lowercase.message',
    defaultMessage: 'This password must contain at least 1 lower case letter.',
    description: 'Error message for password without a lower case letter',
  },
  'username.format.validation.message': {
    id: 'username.format.validation.message',
    defaultMessage:
      'Usernames can only contain letters (A-Z, a-z), numerals (0-9), underscores (_), and hyphens (-). Usernames cannot contain spaces',
    description:
      'Validation message that appears when username format is invalid',
  },
  // Error messages
  'registration.request.failure.header': {
    id: 'registration.request.failure.header',
    defaultMessage: "We couldn't create your account.",
    description: 'error message when registration failure.',
  },
  'registration.empty.form.submission.error': {
    id: 'registration.empty.form.submission.error',
    defaultMessage: 'Please check your responses and try again.',
    description:
      'Error message that appears on top of the form when empty form is submitted',
  },
  'registration.request.server.error': {
    id: 'registration.request.server.error',
    defaultMessage:
      'An error has occurred. Try refreshing the page, or check your internet connection.',
    description: 'Error message for internal server error.',
  },
  'registration.rate.limit.error': {
    id: 'registration.rate.limit.error',
    defaultMessage: 'Too many failed registration attempts. Try again later.',
    description:
      'Error message that appears when an anonymous user has made too many failed registration attempts',
  },
  'registration.tpa.session.expired': {
    id: 'registration.tpa.session.expired',
    defaultMessage: 'Registration using {provider} has timed out.',
    description: '',
  },
  'registration.tpa.authentication.failure': {
    id: 'registration.tpa.authentication.failure',
    defaultMessage:
      'We are sorry, you are not authorized to access {platform_name} via this channel. ' +
      'Please contact your learning administrator or manager in order to access {platform_name}.' +
      '{lineBreak}{lineBreak}Error Details:{lineBreak}{errorMessage}',
    description: 'Error message third party authentication pipeline fails',
  },
  // Terms of Service and Honor Code
  'terms.of.service.and.honor.code': {
    id: 'terms.of.service.and.honor.code',
    defaultMessage: 'Terms of Service and Honor Code',
    description:
      'Text for the hyperlink that redirects user to terms of service and honor code',
  },
  'privacy.policy': {
    id: 'privacy.policy',
    defaultMessage: 'Privacy Policy',
    description: 'Text for the hyperlink that redirects user to privacy policy',
  },
  'honor.code': {
    id: 'honor.code',
    defaultMessage: 'Honor Code',
    description: 'Text for the hyperlink that redirects user to the honor code',
  },
  'terms.of.service': {
    id: 'terms.of.service',
    defaultMessage: 'Terms of Service',
    description:
      'Text for the hyperlink that redirects user to the terms of service',
  },
  'customized.courses.checkbox': {
    id: 'customized.courses.checkbox',
    defaultMessage:
      'Support education research by providing additional information',
    description: '',
  },
  'customized.courses.optional.label': {
    id: 'customized.courses.optional.label',
    defaultMessage: 'Optional',
    description: '',
  },
  'intro.page.title': {
    id: 'intro.page.title',
    defaultMessage: 'Welcome!',
    description: '',
  },
  'intro.page.subtitle': {
    id: 'intro.page.subtitle',
    defaultMessage: 'Create your account and start learning your way.',
    description: '',
  },
  'intro.page.already.registered.text': {
    id: 'intro.page.already.registered.text',
    defaultMessage: 'Already have an account?',
    description: '',
  },
  'intro.page.sign.in.here.link': {
    id: 'intro.page.sign.in.here.link',
    defaultMessage: 'Log in',
    description: '',
  },
  'intro.page.button.text': {
    id: 'intro.page.button.text',
    defaultMessage: 'Sign in with your email',
    description: '',
  },

  'intro.page.create.account.header': {
    id: 'intro.page.create.account.header',
    defaultMessage: 'Create Account',
    description: 'Manual registration page',
  },
  'intro.page.create.an.account.subtitle': {
    id: 'intro.page.create.an.account.subtitle',
    defaultMessage: "Next stop - personal development. Let's go!",
    description: '',
  },
  'manual.account.creation.page.title': {
    id: 'manual.account.creation.page.title',
    defaultMessage: 'Hi {firstName}!',
    description: '',
  },
  'manual.account.creation.page.subtitle': {
    id: 'manual.account.creation.page.subtitle',
    defaultMessage: 'Next stop - personal development. Let’s go!',
    description: '',
  },
  'manual.account.creation.page.button.text': {
    id: 'manual.account.creation.page.button.text',
    defaultMessage: 'Send me a code to email',
    description: '',
  },
  'sso.account.creation.account.validation.title': {
    id: 'sso.account.creation.account.validation.title',
    defaultMessage: 'Verify your details',
    description:
      'a heading for the manual account creation page when SSO account validation is required',
  },
  'sso.account.creation.account.validation.subtitle': {
    id: 'sso.account.creation.account.validation.subtitle',
    defaultMessage: 'Making sure everything\'s correct{lineBreak}before creating your account',
    description:
      'validation subtitle for the manual account creation page when SSO account validation is required',
  },
  'sso.account.creation.account.connected.with': {
    id: 'sso.account.creation.account.connected.with',
    defaultMessage: 'Signed in via {providerName}',
    description:
      'A message that appears when SSO account validation is required',
  },
  'sso.account.creation.duplicate.email.error': {
    id: 'sso.account.creation.duplicate.email.error',
    defaultMessage: 'This email is already in use. Please link your account via {loginLink} or contact support.',
    description:
      'Error message when SSO user tries to register with an email that already exists',
  },
  'sso.account.creation.duplicate.email.login.link': {
    id: 'sso.account.creation.duplicate.email.login.link',
    defaultMessage: 'login',
    description: 'Login link text in duplicate email error',
  },
  // social auth providers
  'provider.google': {
    id: 'provider.google',
    defaultMessage: 'Google',
  },
  'provider.facebook': {
    id: 'provider.facebook',
    defaultMessage: 'Facebook',
  },
  'provider.nis': {
    id: 'provider.nis',
    defaultMessage: 'IDP',
  },
  'provider.edu': {
    id: 'provider.edu',
    defaultMessage: 'Ministry of Education',
  },
  'provider.moe': {
    id: 'provider.moe',
    defaultMessage: 'Ministry of Education',
  },
  'provider.generic': {
    id: 'provider.generic',
    defaultMessage: '{providerName}',
  },
  'email.verification.page.title': {
    id: 'email.verification.page.title',
    defaultMessage: 'We sent you an email!',
    description: '',
  },
  'email.verification.page.subtitle': {
    id: 'email.verification.page.subtitle',
    defaultMessage: 'An email with a code has been sent to {email}. {enter} Use this code to activate your {platform_name} account.',
    description: '',
  },
  'email.verification.page.button.text': {
    id: 'email.verification.page.button.text',
    defaultMessage: 'Enter code',
    description: '',
  },
  'verification.code.page.subtitle': {
    id: 'verification.code.page.subtitle',
    defaultMessage: 'Enter the verification code that was sent to your email',
    description: '',
  },
  'verification.code.input.invalid.value': {
    id: 'verification.code.input.invalid.value',
    defaultMessage: 'The code entered is incorrect. You can try entering the code again.',
    description: '',
  },
  'email.verification.page.did.not.recieved.text': {
    id: 'email.verification.page.did.not.recieved.text',
    defaultMessage: 'Didn\'t get it?',
    description: '',
  },
  'email.verification.page.code.resent.text': {
    id: 'email.verification.page.code.resent.text',
    defaultMessage: 'We have resent the code to your email address',
    description: '',
  },
  'email.verification.page.send.again.link': {
    id: 'email.verification.page.send.again.link',
    defaultMessage: 'Send again',
    description: '',
  },
  'email.verification.page.button.text': {
    id: 'email.verification.page.button.text',
    defaultMessage: 'Enter Code',
    description: '',
  },
    'confirm.email.verification.code.page.button.text': {
    id: 'confirm.email.verification.code.page.button.text',
    defaultMessage: 'Enter Code',
    description: '',
  },
  'registration.confirmation.page.title': {
    id: 'registration.confirmation.page.title',
    defaultMessage:
      "{fullName}, Your account is verified! {enter}",
    description: '',
  },
  'registration.confirmation.page.subtitle': {
    id: 'registration.confirmation.page.subtitle',
    defaultMessage:
      'We want to know you better and maybe help you with some recommendations. {enter} Feel free to answer some short questions, or skip them entirely and get to learning!',
    description: '',
  },
  'registration.confirmation.page.could.not.verify.title': {
    id: 'registration.confirmation.page.could.not.verify.title',
    defaultMessage: 'We cannot verify {enter} your email...',
    description: '',
  },
  'registration.confirmation.page.could.not.verify.subtitle': {
    id: 'registration.confirmation.page.could.not.verify.subtitle',
    defaultMessage:
      "We encountered an issue trying to authenticate your account. Please try again later. {enter} If the issue persists, contact our",
    description: '',
  },
  'registration.confirmation.page.could.not.verify.contact.support.text': {
    id: 'registration.confirmation.page.could.not.verify.contact.support.text',
    defaultMessage: 'Technical Support',
    description: '',
  },
  'registration.confirmation.page.could.not.verify.button': {
    id: 'registration.confirmation.page.could.not.verify.button',
    defaultMessage: 'Send me another verification email',
    description: '',
  },
  'registration.confirmation.page.course.text': {
    id: 'registration.confirmation.page.course.text',
    defaultMessage: 'Not now, I want to continue the course.',
    description: '',
  },
  'registration.confirmation.page.catalog.text': {
    id: 'registration.confirmation.page.catalog.text',
    defaultMessage: 'Not now, I want to discover courses myself',
    description: '',
  },
  'registration.confirmation.page.button.text': {
    id: 'registration.confirmation.page.button.text',
    defaultMessage: 'Give me suggestions',
    description: '',
  },
  'additional.information.education.tab.label': {
    id: 'additional.information.education.tab.label',
    defaultMessage: 'Education',
    description: '',
  },
  'additional.information.degree.tab.label': {
    id: 'additional.information.degree.tab.label',
    defaultMessage: 'Degree',
    description: '',
  },
  'additional.information.gender.tab.label': {
    id: 'additional.information.gender.tab.label',
    defaultMessage: 'Gender',
    description: '',
  },
  'additional.information.year.of.birth.tab.label': {
    id: 'additional.information.year.of.birth.tab.label',
    defaultMessage: 'Birth Year',
    description: '',
  },
  'additional.information.residence.tab.label': {
    id: 'additional.information.residence.tab.label',
    defaultMessage: 'Residence',
    description: '',
  },
  'additional.information.education.title': {
    id: 'additional.information.education.title',
    defaultMessage: 'What is your highest level of education?',
    description: '',
  },
  'additional.information.degree.title': {
    id: 'additional.information.degree.title',
    defaultMessage: 'What is the highest academic degree you have completed?',
    description: '',
  },
  'additional.information.school.education': {
    id: 'additional.information.school.education',
    defaultMessage: 'High school',
    description: '',
  },
  'additional.information.education.academic': {
    id: 'additional.information.education.academic',
    defaultMessage: 'Higher education',
    description: '',
  },
  'additional.information.education.none': {
    id: 'additional.information.education.none',
    defaultMessage: 'No formal education',
    description: '',
  },
  'additional.information.gender.title': {
    id: 'additional.information.gender.title',
    defaultMessage: 'What is your Gender?',
    description: '',
  },
  'additional.information.year.of.birth.title': {
    id: 'additional.information.year.of.birth.title',
    defaultMessage: 'What year were you born?',
    description: '',
  },
  'additional.information.residence.title': {
    id: 'additional.information.residence.title',
    defaultMessage: 'Where do you live?',
    description: '',
  },
  'registration.process.completion.page.title': {
    id: 'registration.process.completion.page.title',
    defaultMessage: "{fullName}, You're all set!",
    description: '',
  },
  'registration.process.completion.page.subtitle': {
    id: 'registration.process.completion.page.subtitle',
    defaultMessage:
      'Now that we\'ve gotten to know you a little better, we\'ve prepared course recommendations for you in your personal area. {enter} It\'s time to explore courses tailored to your interests and preferences.',
    description: '',
  },
  'registration.process.completion.page.support.text': {
    id: 'registration.process.completion.page.support.text',
    defaultMessage:
      'The Campus IL team is here to support you throughout your learning Journey. {enter} Good luck!',
    description: '',
  },
  'registration.process.completion.page.button.course': {
    id: 'registration.process.completion.page.button.course',
    defaultMessage: 'Continue the course',
    description: '',
  },
  'registration.process.completion.page.button.catalog': {
    id: 'registration.process.completion.page.button.catalog',
    defaultMessage: 'To course catalog / Back to learning',
    description: '',
  },
  'accept.recieving.courses.and.projects.updates': {
    id: 'accept.recieving.courses.and.projects.updates',
    defaultMessage:
      'I agree to receive updates about new courses, content, and projects.',
    description: '',
  },
  'logistration.email.input.placeholder': {
    id: 'logistration.email.input.placeholder',
    defaultMessage: 'Enter your email address',
    description: '',
  },
  'logistration.email.input.label': {
    id: 'logistration.email.input.label',
    defaultMessage: 'Email address',
    description: '',
  },
  'password.input.choose.password.placeholder': {
    id: 'password.input.choose.password.placeholder',
    defaultMessage: 'Choose a password',
    description: '',
  },
    'password.input.choose.password.label': {
    id: 'password.input.choose.password.label',
    defaultMessage: 'Password',
    description: '',
  },
  'password.input.confirm.password.placeholder': {
    id: 'password.input.confirm.password.placeholder',
    defaultMessage: 'Confirm your password',
    description: '',
  },
  'password.input.confirm.password.label': {
    id: 'password.input.confirm.password.label',
    defaultMessage: 'Validate password',
    description: 'Confirm password field label for the reset password page.',
  },
  'year.of.birth.select.label': {
    id: 'year.of.birth.select.label',
    defaultMessage: 'Select your birth year',
    description: '',
  },
  'continue.button': {
    id: 'continue.button',
    defaultMessage: 'Continue',
    description: '',
  },
  'skip.question.button': {
    id: 'skip.question.button',
    defaultMessage: 'Skip for now',
    description: '',
  },
  'customized.courses.city.label': {
    id: 'customized.courses.city.label',
    defaultMessage: 'City',
    description: '',
  },
  'customized.courses.country.label': {
    id: 'customized.courses.country.label',
    defaultMessage: 'Country',
    description: '',
  },
  // miscellaneous strings
  'registration.username.suggestion.label': {
    id: 'registration.username.suggestion.label',
    defaultMessage: 'Suggested:',
    description: 'Suggested usernames label text.',
  },
  'did.you.mean.alert.text': {
    id: 'did.you.mean.alert.text',
    defaultMessage: 'Did you mean',
    description: 'Did you mean alert suggestion',
  },
  'email.conflict.error': {
    id: 'email.conflict.error',
    defaultMessage: 'This email address is already in use (did you stop the registration process midway?) Please try to {loginLink}',
    description: 'Error message when email already exists with login link',
  },
  'email.conflict.login.link': {
    id: 'email.conflict.login.link',
    defaultMessage: 'log in',
    description: 'Login link text in email conflict error',
  },
});

export default messages;
